// src/components/SystemHubSolicitacoes.js
import React, { useState, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';
import api from '../services/api';
import './SystemHubSolicitacoes.css'; 
import { FaKey, FaCheck, FaTimes, FaEye, FaFilter, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import LicenseApprovalModal from './LicenseApprovalModal';

// --- NOVO MODAL DE VISUALIZAÇÃO (SOMENTE LEITURA) ---
function LicenseViewModal({ request, onClose }) {
    if (!request) return null;

    const isApproved = request.status === 'aprovada';

    return (
        <div className="modal-overlay">
            <div className="modal-content modal-content--simple" style={{ maxWidth: '500px' }}>
                <header className="modal-header-simple">
                    <h3 style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <FaEye color="#101C5D" /> Detalhes da Solicitação
                    </h3>
                    <button onClick={onClose} className="modal-close-button" title="Fechar">
                        <FaTimes />
                    </button>
                </header>
                <div className="modal-body-simple" style={{ color: '#334155' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '20px' }}>
                        <div>
                            <small style={{ color: '#64748b', fontWeight: 'bold' }}>Cliente</small>
                            <p style={{ margin: '4px 0', fontSize: '1.1rem' }}>{request.nome_empresa}</p>
                        </div>
                        <div>
                            <small style={{ color: '#64748b', fontWeight: 'bold' }}>Solicitante</small>
                            <p style={{ margin: '4px 0' }}>{request.solicitante_nome}</p>
                        </div>
                        <div>
                            <small style={{ color: '#64748b', fontWeight: 'bold' }}>Data do Pedido</small>
                            <p style={{ margin: '4px 0' }}>{new Date(request.data_solicitacao).toLocaleDateString('pt-BR')}</p>
                        </div>
                        <div>
                            <small style={{ color: '#64748b', fontWeight: 'bold' }}>Pedido</small>
                            <p style={{ margin: '4px 0' }}>
                                <strong style={{ color: '#101C5D' }}>+{request.licencas_solicitadas}</strong> slots
                            </p>
                        </div>
                    </div>

                    <div style={{ background: '#f8fafc', padding: '15px', borderRadius: '8px', marginBottom: '20px' }}>
                        <small style={{ color: '#64748b', fontWeight: 'bold' }}>Justificativa do Cliente:</small>
                        <p style={{ margin: '8px 0 0', fontStyle: 'italic' }}>
                            "{request.justificativa || 'Nenhuma justificativa fornecida.'}"
                        </p>
                    </div>

                    <hr style={{ border: 'none', borderTop: '1px solid #e2e8f0', margin: '20px 0' }} />

                    <div>
                        <h4 style={{ margin: '0 0 10px', color: '#0f172a' }}>Decisão da Administração</h4>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                            <span style={{
                                padding: '6px 12px', borderRadius: '20px', fontSize: '0.85rem', fontWeight: 'bold',
                                background: isApproved ? '#dcfce7' : '#fee2e2',
                                color: isApproved ? '#166534' : '#991b1b',
                                display: 'flex', alignItems: 'center', gap: '6px'
                            }}>
                                {isApproved ? <FaCheck /> : <FaTimes />} {request.status.toUpperCase()}
                            </span>
                            <span style={{ fontSize: '0.9rem', color: '#64748b' }}>
                                em {new Date(request.data_decisao).toLocaleDateString('pt-BR')}
                            </span>
                        </div>
                        
                        {!isApproved && request.motivo_rejeicao && (
                            <div style={{ background: '#fef2f2', borderLeft: '4px solid #ef4444', padding: '10px 15px', borderRadius: '4px' }}>
                                <small style={{ color: '#991b1b', fontWeight: 'bold' }}>Motivo da Rejeição:</small>
                                <p style={{ margin: '4px 0 0', color: '#7f1d1d' }}>{request.motivo_rejeicao}</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

// --- COMPONENTE PRINCIPAL ---
export default function SystemHubSolicitacoes() {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    
    // Filtros e Paginação
    const [clientes, setClientes] = useState([]);
    const [selectedClienteId, setSelectedClienteId] = useState('');
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const limit = 10; // Registros por página
    
    // Modais
    const [selectedRequest, setSelectedRequest] = useState(null); // Para processar
    const [viewRequest, setViewRequest] = useState(null); // Para visualizar (olho)

    // Busca clientes para o Select (Filtro)
    const fetchClientes = async () => {
        try {
            const { data } = await api.get('/api/clientes-sistema/list');
            setClientes(Array.isArray(data) ? data : []);
        } catch (error) {
            toast.error("Falha ao carregar lista de clientes para o filtro.");
        }
    };

    const fetchRequests = useCallback(async () => {
        setLoading(true);
        try {
            const { data } = await api.get('/api/system-hub/licensing-requests', {
                params: { page, limit, cliente_id: selectedClienteId }
            });
            setRequests(data.items || []);
            setTotalPages(data.totalPages || 1);
        } catch (error) {
            toast.error("Falha ao carregar a lista de solicitações.");
        } finally {
            setLoading(false);
        }
    }, [page, limit, selectedClienteId]);

    useEffect(() => {
        fetchClientes();
    }, []);

    useEffect(() => {
        fetchRequests();
    }, [fetchRequests]);

    // Reseta a página para 1 sempre que o filtro de cliente mudar
    const handleClienteFilterChange = (e) => {
        setSelectedClienteId(e.target.value);
        setPage(1);
    };

    const handleDecisionSuccess = () => {
        setSelectedRequest(null);
        fetchRequests();
    };

    return (
        <div className="sh-solicitacoes-wrapper">
            <div className="sh-solicitacoes-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '15px' }}>
                <h1 style={{ display: 'flex', alignItems: 'center', gap: '10px', margin: 0 }}>
                    <FaKey color="#101C5D" /> Solicitações de Licença
                </h1>

                {/* BARRA DE FILTRO ESTATÍSTICA */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', background: '#fff', padding: '8px 15px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                    <FaFilter color="#64748b" />
                    <select 
                        value={selectedClienteId} 
                        onChange={handleClienteFilterChange}
                        style={{ border: 'none', background: 'transparent', outline: 'none', color: '#334155', fontWeight: 'bold', cursor: 'pointer' }}
                    >
                        <option value="">Todos os Clientes</option>
                        {clientes.map(c => (
                            <option key={c.id} value={c.id}>{c.nome_empresa}</option>
                        ))}
                    </select>
                </div>
            </div>
            
            <div className="sh-solicitacoes-card" style={{ marginTop: '20px' }}>
                {loading && requests.length === 0 ? (
                    <div className="sh-solicitacoes-loading" style={{ padding: '40px', textAlign: 'center', color: '#64748b' }}>Carregando solicitações...</div>
                ) : (
                    <>
                        <table className="sh-solicitacoes-table">
                            <thead>
                                <tr>
                                    <th className="col-sol-cliente">Cliente</th>
                                    <th className="col-sol-solicitante">Solicitante</th>
                                    <th className="col-sol-data">Data</th>
                                    <th className="col-sol-pedido">Pedido</th>
                                    <th className="col-sol-status">Status</th>
                                    <th className="col-sol-acoes" style={{ textAlign: 'center' }}>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {requests.map(req => (
                                    <tr key={req.id} style={{ opacity: req.status !== 'pendente' ? 0.8 : 1 }}>
                                        <td className="col-sol-cliente">
                                            <strong>{req.nome_empresa}</strong>
                                        </td>
                                        <td className="col-sol-solicitante">{req.solicitante_nome}</td>
                                        <td className="col-sol-data">
                                            {new Date(req.data_solicitacao).toLocaleDateString('pt-BR')}
                                        </td>
                                        <td className="col-sol-pedido">
                                            <span className="sh-pedido-badge" style={{ fontWeight: 'bold', color: '#101C5D' }}>
                                                +{req.licencas_solicitadas}
                                            </span> 
                                            <span className="sh-pedido-info" style={{ fontSize: '0.85rem', color: '#64748b' }}> (atual: {req.licencas_atuais})</span>
                                        </td>
                                        <td className="col-sol-status">
                                            <span className={`sh-solicitacoes-badge status-${req.status}`}>
                                                {req.status}
                                            </span>
                                        </td>
                                        <td className="col-sol-acoes" style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
                                            {req.status === 'pendente' ? (
                                                <button 
                                                    title="Processar Solicitação" 
                                                    onClick={() => setSelectedRequest(req)} 
                                                    className="btn-ultra primary"
                                                    style={{ padding: '6px 12px', fontSize: '0.85rem' }}
                                                >
                                                    Processar
                                                </button>
                                            ) : (
                                                <button 
                                                    title="Ver Detalhes da Decisão" 
                                                    onClick={() => setViewRequest(req)} 
                                                    className="btn-ultra secondary"
                                                    style={{ padding: '6px 12px', fontSize: '0.85rem', display: 'flex', alignItems: 'center', gap: '6px' }}
                                                >
                                                    <FaEye /> Visualizar
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        
                        {requests.length === 0 && !loading && (
                            <div className="sh-solicitacoes-empty" style={{ padding: '40px', textAlign: 'center', color: '#64748b' }}>
                                Nenhuma solicitação de licença encontrada para este filtro.
                            </div>
                        )}

                        {/* PAGINAÇÃO */}
                        {totalPages > 1 && (
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '15px', padding: '20px' }}>
                                <button 
                                    className="btn-ultra secondary" 
                                    disabled={page === 1} 
                                    onClick={() => setPage(p => p - 1)}
                                    style={{ padding: '8px' }}
                                >
                                    <FaChevronLeft />
                                </button>
                                <span style={{ fontWeight: 'bold', color: '#334155' }}>Página {page} de {totalPages}</span>
                                <button 
                                    className="btn-ultra secondary" 
                                    disabled={page === totalPages} 
                                    onClick={() => setPage(p => p + 1)}
                                    style={{ padding: '8px' }}
                                >
                                    <FaChevronRight />
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>

            {/* MODAL DE APROVAÇÃO (O seu existente) */}
            {selectedRequest && (
                <LicenseApprovalModal 
                    request={selectedRequest}
                    onClose={() => setSelectedRequest(null)}
                    onSuccess={handleDecisionSuccess}
                />
            )}

            {/* MODAL DE VISUALIZAÇÃO (Novo, somente leitura) */}
            {viewRequest && (
                <LicenseViewModal 
                    request={viewRequest}
                    onClose={() => setViewRequest(null)}
                />
            )}
        </div>
    );
}